import { useEffect, useState } from 'react';

const SideCardContent = ({ titles }: { titles: string[] }) => {
  const [showCTASidebar, setShowCTASidebar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset;
      if (scrollPosition > 50) {
        setShowCTASidebar(false);
      } else {
        setShowCTASidebar(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {showCTASidebar && (
        <div
          className={`hidden md:block w-64 h-60 fixed top-1/4 mt-4 right-2 transform -translate-y-1/2 rounded-lg space-y-2 overflow-scroll bg-slate-50 border-gray-200 border-2 p-2
          }`}
        >
          <h1>Table of contents</h1>
          {titles.map((title: string, index: number) => (
            <div key={index}>
              <button className="text-left text-sm border-l-2 pl-2 border-grey-50">
                {title}
              </button>
            </div>
          ))}

          <div className="rounded-full w-[224] mx-auto"></div>
        </div>
      )}
    </>
  );
};

export default SideCardContent;
